var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('statistic-card-horizontal',{attrs:{"is-loading":_vm.isLoading,"icon":"UserTieIcon","statistic":_vm.chartData,"statistic-title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }